var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.warningClass},[_c('common-icon',{attrs:{"name":"white-warning","size":"medium-large"}}),_c('span',{class:`warning__text-${_vm.size}`},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }